import { authService } from './auth.service';

const API_URL = import.meta.env.VITE_API_URL || 'http://localhost:8787';

export interface User {
  id: string;
  email: string;
  name: string;
  role: string;
  isActive: boolean;
  avatarUrl?: string;
  phone?: string;
  balance?: number;
  createdAt?: number;
  updatedAt?: number;
  lastLogin?: number;
}

export interface CreateUserData {
  email: string;
  name: string;
  password: string;
  role: string;
  phone?: string;
}

export interface UpdateUserData {
  name?: string;
  role?: string;
  isActive?: boolean;
  phone?: string;
  avatarUrl?: string;
}

export const userService = {
  // Obtener todos los usuarios
  async getUsers(): Promise<User[]> {
    const response = await authService.fetchWithAuth(`${API_URL}/api/users`);
    return response.data || [];
  },

  // Obtener un usuario por ID
  async getUser(id: string): Promise<User> {
    const response = await authService.fetchWithAuth(`${API_URL}/api/users/${id}`);
    return response.data;
  },

  // Crear un nuevo usuario
  async createUser(data: CreateUserData): Promise<User> {
    const response = await authService.fetchWithAuth(`${API_URL}/api/users`, {
      method: 'POST',
      body: JSON.stringify(data)
    });
    return response.data;
  },

  // Actualizar un usuario
  async updateUser(id: string, data: UpdateUserData): Promise<User> {
    const response = await authService.fetchWithAuth(`${API_URL}/api/users/${id}`, {
      method: 'PUT',
      body: JSON.stringify(data)
    });
    return response.data;
  },

  // Eliminar un usuario (desactivar)
  async deleteUser(id: string): Promise<void> {
    await authService.fetchWithAuth(`${API_URL}/api/users/${id}`, {
      method: 'DELETE'
    });
  },

  // Activar/Desactivar un usuario
  async toggleUserStatus(id: string, isActive: boolean): Promise<User> {
    const response = await authService.fetchWithAuth(`${API_URL}/api/users/${id}/status`, {
      method: 'PATCH',
      body: JSON.stringify({ isActive })
    });
    return response.data;
  },

  // Asignar rol a un usuario
  async assignRole(id: string, role: string): Promise<User> {
    const response = await authService.fetchWithAuth(`${API_URL}/api/users/${id}/role`, {
      method: 'PATCH',
      body: JSON.stringify({ role })
    });
    return response.data;
  },

  // Obtener usuarios por rol
  async getUsersByRole(role: string): Promise<User[]> {
    const response = await authService.fetchWithAuth(`${API_URL}/api/users?role=${role}`);
    return response.data || [];
  },

  // Obtener estadísticas de usuarios
  async getUserStats(): Promise<{ total: number; byRole: Record<string, number>; active: number; inactive: number }> {
    const response = await authService.fetchWithAuth(`${API_URL}/api/users/stats`);
    return response.data;
  }
};